import { useCompany } from '../../providers/CompanyProvider';
import { Select, Badge } from '../../ui';

// Company Switcher (Slice 6C-2). A single membership renders a compact, non-interactive
// indicator — no misleading selectable control when there is nothing to switch between.
// Multiple memberships render an accessible native Select bound only to the discovered active
// membership set (never an arbitrary company id). Disabled while a switch is in flight; a
// failed switch shows only safe, presentation-mapped Georgian text next to the control — never
// raw backend/AppError text — while the current company/app stays intact.
export function CompanySwitcher(): JSX.Element {
  const { memberships, activeCompany, setActiveCompany, selecting, errorMessage } = useCompany();

  if (memberships.length === 0) {
    return <span className="text-sm text-fg-muted">კომპანია არ არის</span>;
  }

  if (memberships.length === 1) {
    return (
      <div className="flex items-center gap-2">
        <span className="sr-only">აქტიური კომპანია</span>
        <Badge tone="neutral">{activeCompany?.name ?? memberships[0]!.company.name}</Badge>
      </div>
    );
  }

  const options = memberships.map((m) => ({ value: m.company.id, label: m.company.name }));

  return (
    <div className="flex flex-col gap-1">
      <Select
        value={activeCompany?.id ?? ''}
        onChange={(e) => setActiveCompany(e.target.value)}
        options={options}
        disabled={selecting}
        aria-label="კომპანია"
        className="h-9 w-full min-w-0 max-w-full truncate min-[480px]:w-auto min-[480px]:min-w-[11rem]"
      />
      {errorMessage !== null && (
        <p role="alert" className="text-xs text-danger">
          {errorMessage}
        </p>
      )}
    </div>
  );
}
